<template>
  <Modal :value="open" :onClose="close" :close="false" title="Cliente">
    <b-row class="form-group">
      <span v-if="enableAlertSinief">
        <b-col class="pb-3">
          Atenção! Emissão de NFC-e permitida somente para Consumidor Final conforme previsto no
          Ajuste SINIEF nº 7, de 30 de setembro de 2005.
        </b-col>
      </span>
      <b-col class="busca">
        <Select
          label="Pesquisar Cliente"
          placeholder="Informe o Nome/CPF/CNPJ"
          labelBusca="name"
          v-model="componentClient"
          ref="buscarCliente"
          :options="clientes"
          inputClass="busca-cliente"
          :change="changeClienteSelected"
          :client="componentClient.name"
          :search="searchCliente"
        >
        </Select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Input
          ref="cpfcnpj"
          label="CPF/CNPJ"
          id="cpfcnpj"
          :mask="['###.###.###-##', '##.###.###/####-##']"
          @keypress.enter.prevent="save"
          labelBold
          v-model="componentClient.identification"
        />
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <Checkbox label="Entrega a domicílo" v-model="tradeHomeDelivery" />
      </b-col>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()">Gravar</Button>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash';
import { Modal, Checkbox } from '@/components';
import { Button, Input } from '@/components/Form';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import Select from '../Form/SelectClient';

export default {
  name: 'ModalCliente',
  mixins: [FormatMixin],
  components: {
    Modal,
    Button,
    Select,
    Input,
    Checkbox,
  },
  data() {
    return {
      clientes: [],
      tradeClient: {},
      componentClient: {},
      tradeHomeDelivery: false,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    changeCliente: {
      type: Function,
      required: true,
    },
    cliente: {
      required: true,
    },
    homeDelivery: {
      required: true,
    },
  },
  watch: {
    cliente(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.tradeClient = newValue;
      }
    },
    homeDelivery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.tradeHomeDelivery = newValue;
      }
    },
    open(newValue) {
      if (newValue === true) {
        this.refreshComponentData();
        this.clientes = [];
      }
    },
  },
  computed: {
    enableAlertSinief() {
      return new Date() >= new Date('2026-05-04');
    },
  },
  methods: {
    save() {
      if (this.tradeHomeDelivery) {
        const [address] = this.componentClient?.addressCollection ?? [];

        if (!address || !address.street || !address.number || !address.neighbourhood) {
          this.$toast.error(
            'Para entrega a domicílio é necessário informar um cliente com endereço (logradouro, número e bairro)',
          );
          return;
        }
      }

      this.tradeClient = { ...this.componentClient };
      this.changeCliente({ client: this.tradeClient, homeDelivery: this.tradeHomeDelivery });
    },
    refreshComponentData() {
      this.componentClient = { ...this.tradeClient };
    },
    changeClienteSelected(selectedCliente) {
      if (selectedCliente !== null) {
        const cliente = selectedCliente;
        cliente.identification = this.formatCpfCnpj(cliente.identification);
        this.componentClient = cliente;
        this.$nextTick(() => {
          if (this.$refs.cpfcnpj) {
            this.$refs.cpfcnpj.$children[1].focus();
          }
        });
      }
    },
    searchCliente(search, loading) {
      this.getCliente(loading, search, this);
    },
    getCliente: _.debounce(async (loading, search, vm) => {
      if (search === '' || search === null) {
        return loading(false);
      }

      if (search === undefined) {
        return false;
      }

      const $this = vm;

      $this.clientes = await [];

      const { data } = await $this.$http.post('/person.get-person', {
        search,
        active: true,
        isClient: true,
        maxResults: 10,
      });
      $this.clientes = data;

      loading(false);
      return true;
    }, 350),
  },
};
</script>
